<template>
  <div class="card card-height animate-fade-in">
    <div class="card-header">
      <ChatSelectGroup
        :show-model="false"
        :show-personality="false"
        :show-rag="false"
        v-model:model="selectedModel"
        v-model:model-label="selectedModelLabel"
      />
    </div>
    <div
      class="card-body d-flex flex-column justify-content-center align-items-center px-3 px-md-5 mt-n6"
    >
      <img
        class="configuration-diagram mb-4"
        :src="require('@/assets/img/app/diagram-summary.png')"
        alt="議事録っチャオ"
      />
      <div class="w-100 mt-2 d-flex justify-content-center">
        <div class="input-group input-text-wrapper align-items-end">
          <!-- アップロードエリア -->
          <div class="multisteps-form__content shadow-lg mb-2 w-100">
            <div
              id="dropzone"
              class="form-control dropzone mt-2"
              :class="{ dragging: isDragging, summary: isDragging }"
            >
              <div class="fallback">
                <input name="file" type="file" multiple />
              </div>
            </div>
          </div>
          <!--
          <textarea
            :class="[
              'form-control',
              { 'border-0': true, 'shadow-none': true, expanded: focused },
            ]"
            placeholder="ファイルアップロード後に質問が可能です"
            @focus="focused = true"
            @blur="focused = false"
            v-model="userInput"
            @keydown.enter.exact.prevent="submitMessage"
            @keydown.enter.ctrl="insertNewLine"
            maxlength="7000"
          ></textarea>
          -->
          <!-- 送信ボタン -->
          <!--
          <div
            class="btn btn-icon-only btn-icon-send bg-dark text-white rounded-circle"
            @click="submitMessage"
          >
            <i class="far fa-comment-dots" aria-hidden="true"></i>
          </div>
          -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChatSelectGroup from '@/components/PageLayout/App/ChatSelectGroup.vue'
import Dropzone from 'dropzone'

export default {
  name: 'DefaultCard',
  components: {
    ChatSelectGroup,
  },
  props: {
    model: {
      type: String,
      default: '',
    },
    modelLabel: {
      type: String,
      default: '',
    },
    modelOptions: {
      type: Array,
      required: true,
    },
  },
  emits: [
    'file-added',
    //'input-message',
    'handle-selected-model',
    'handle-selected-model-label',
  ],
  data() {
    return {
      userInput: '',
      focused: false,
      selectedModel: this.model,
      selectedModelLabel: this.modelLabel,
      selectedModelOptions: this.modelOptions,
      isDragging: false,
    }
  },
  mounted() {
    Dropzone.autoDiscover = false
    var drop = document.getElementById('dropzone')
    const vm = this
    new Dropzone(drop, {
      url: '#',
      addRemoveLinks: false,
      previewsContainer: false,
      // ✅ 日本語のメッセージ設定
      dictDefaultMessage:
        'こちらにファイルをドロップ<br/>または<br/><button class="btn btn-sm bg-gradient-secondary mt-2 mb-0 py-2"><span class="fas fa-cloud-upload-alt fa-lg me-1"></span> ファイルを選択ください</button>',
      dictFallbackMessage:
        'このブラウザではドラッグ＆ドロップによるアップロードがサポートされていません',
      dictInvalidFileType: 'この種類のファイルはアップロードできません',
      dictFileTooBig:
        'ファイルが大きすぎます（{{filesize}}MB）。最大サイズ: {{maxFilesize}}MB。',
      dictResponseError:
        'サーバーでエラーが発生しました。ステータスコード {{statusCode}}',
      dictCancelUpload: 'アップロードをキャンセル',
      dictCancelUploadConfirmation: '本当にアップロードをキャンセルしますか？',
      dictRemoveFile: 'ファイルを削除',
      dictMaxFilesExceeded: 'これ以上ファイルをアップロードできません',
      acceptedFiles:
        '.mp3, .wav, .flac, .m4a, .mp4, .avi, .webm, .mpeg, .mpga, .mov',
      // ファイル追加時に emit
      init: function () {
        this.on('addedfile', (file) => {
          // Vueコンポーネントの $emit を使用
          vm.$emit('file-added', file)
        })
      },
    })
  },
  methods: {
    //submitMessage() {
    //  const trimmed = this.userInput.trim()
    //  if (trimmed) {
    //    this.$emit('input-message', trimmed)
    //    this.userInput = ''
    //  }
    //},
    insertNewLine(event) {
      const textarea = event.target
      const start = textarea.selectionStart
      const end = textarea.selectionEnd
      this.userInput =
        this.userInput.substring(0, start) +
        '\n' +
        this.userInput.substring(end)
      this.$nextTick(() => {
        textarea.selectionStart = textarea.selectionEnd = start + 1
      })
    },
  },
  watch: {
    selectedModel(newVal) {
      this.$emit('handle-selected-model', newVal)
    },
    selectedModelLabel(newVal) {
      this.$emit('handle-selected-model-label', newVal)
    },
  },
}
</script>
